var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.333 3.167a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666M7.5 4a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2zM3.333 8.166a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667M7.5 9a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2zm-4.167 4.167a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666M7.5 14a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2z"
})));
SvgList.displayName = "SvgList";
export { SvgList as ReactComponent };
export default SvgList;